export function splitName(name: string): { firstName: string; lastName: string } {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { firstName: "", lastName: "" };
  if (parts.length === 1) return { firstName: parts[0], lastName: "" };
  return { firstName: parts[0], lastName: parts.slice(1).join(" ") };
}

/**
 * Email normalization guidance (Google Ads):
 * - lowercase
 * - remove ALL spaces (before/after/in-between)
 * - do not attempt to "fix" missing domains; just return empty if invalid-ish
 */
export function normalizeEmail(email: string): string {
  const normalized = (email || "").toLowerCase().replaceAll(/\s+/g, "");
  // Basic sanity: must include domain part; we do not fabricate/guess it
  if (!normalized.includes("@")) return "";
  const [, domain] = normalized.split("@");
  if (!domain || !domain.includes(".")) return "";
  return normalized;
}

/**
 * Name normalization guidance (Google Ads):
 * - lowercase
 * - trim + collapse repeated whitespace
 * - remove common honorific prefixes / suffixes like "Mrs." / "Jr."
 * - keep accents (e.g. zoë, pérez) — no ASCII folding
 */
export function normalizeFullName(name: string): string {
  const collapsed = (name || "").trim().replaceAll(/\s+/g, " ");
  if (!collapsed) return "";

  // Split into tokens, preserving accents; strip punctuation for matching only
  const rawTokens = collapsed.split(" ").filter(Boolean);
  if (rawTokens.length === 0) return "";

  const prefixes = new Set(["mr", "mrs", "ms", "miss", "dr", "prof", "sir", "madam", "mx"]);
  const suffixes = new Set(["jr", "sr", "ii", "iii", "iv", "phd", "md"]);

  const tokens = [...rawTokens];

  const first = tokens[0];
  const firstKey = first.toLowerCase().replaceAll(/[.,]/g, "");
  if (prefixes.has(firstKey)) {
    tokens.shift();
  }

  const last = tokens[tokens.length - 1];
  const lastKey = (last || "").toLowerCase().replaceAll(/[.,]/g, "");
  if (suffixes.has(lastKey)) {
    tokens.pop();
  }

  return tokens.join(" ").toLowerCase().trim();
}
